
define('eteration/widgets/ui-date-formats',[], function() {

	var dateFormats = {};

	dateFormats['tr'] = {
		fulldate 			: 'D MMMM YYYY dddd',  // ok
		date 				: 'D MMMM YYYY', // ok
		fulldayfullmonth 	: 'D MMMM dddd',// ok
		datewday 			: 'D MMM ddd',// ok
		dayfullmonth 		: 'D MMMM',// ok
		dayshortmonth 		: 'D MMM',// ok
		daytextday 			: 'ddd D', // ok
		
		daymonth : 'DD MMM',
		shortmonthyear : 'MMM YYYY', // ? 		Haz 2015
		monthyear : 'MMMM YYYY', // ? 			Haziran 2015
		
		combodateTemplate : 'D MMMM YYYY',
		combodateFormat : 'YYYY-MM-DD',

		fulldatewshortmonth: 'DD MMM dddd YYYY' // 13 May Persembe 2025
	};
	
	dateFormats['en'] = {		
			fulldate 			: 'dddd, MMMM D, YYYY', // ok
			date 				: 'MMMM D, YYYY', // ok
			fulldayfullmonth 	: 'dddd, MMMM D', // ok
			datewday 			: 'ddd, MMM D', // ok
			dayfullmonth 		: 'MMMM D', // ok
			dayshortmonth 		: 'MMM D', // ok
			daytextday 			: 'ddd D', // ok
			
			daymonth : 'DD MMM',
			shortmonthyear : 'MMM YYYY',
			monthyear : 'MMMM YYYY',
			
			combodateTemplate : 'D MMMM YYYY',
			combodateFormat : 'YYYY-MM-DD',

			fulldatewshortmonth: 'DD MMM dddd YYYY' // 13 May Persembe 2025
		};
	
	
	dateFormats['ko'] = {		
			fulldate 			: 'YYYY년 MMMM D일, dddd', // ok
			date 				: 'MMMM D, YYYY', // ok
			fulldayfullmonth 	: 'MMMM D일, dddd', // ok
			datewday 			: 'ddd, MMM D', // ok
			dayfullmonth 		: 'MMMM D', // ok
			dayshortmonth 		: 'MMM D', // ok
			daytextday 			: 'ddd D', // ok
			
			daymonth : 'DD MMM',
			shortmonthyear : 'MMM YYYY',
			monthyear : 'MMMM YYYY',
			
			combodateTemplate : 'D MMMM YYYY',
			combodateFormat : 'YYYY-MM-DD',

			fulldatewshortmonth: 'DD MMM dddd YYYY' // 13 May Persembe 2025
	};
	

	dateFormats['ar'] = {		
		fulldate 			: 'YYYY MMMM D dddd', // OK
		date 				: 'D MMMM YYYY', // OK
		fulldayfullmonth 	: 'MMMM D dddd', // OK
		datewday 			: 'MMM D ddd', // OK
		dayfullmonth 		: 'D MMMM', // OK
		dayshortmonth 		: 'D MMM', // OK
		daytextday 			: 'D ddd', // OK
	
		daymonth : 'DD MMM',
		shortmonthyear : 'MMM YYYY',
		monthyear : 'MMMM YYYY',
		
		combodateTemplate : 'D MMMM YYYY',
		combodateFormat : 'YYYY-MM-DD',

		fulldatewshortmonth: 'DD MMM dddd YYYY' // 13 May Persembe 2025
	};

	dateFormats['de'] = {		
		fulldate 			: 'dddd, D. MMMM YYYY', // OK
		date 				: 'D. MMMM YYYY', // OK
		fulldayfullmonth 	: 'dddd, D. MMMM', // OK
		datewday 			: 'ddd, D. MMM', // OK
		dayfullmonth 		: 'D. MMMM', // OK
		dayshortmonth 		: 'D. MMM', // OK
		daytextday 			: 'ddd, D.', // OK
		
		daymonth : 'DD MMM',
		shortmonthyear : 'MMM YYYY',
		monthyear : 'MMMM YYYY',
		
		combodateTemplate : 'D MMMM YYYY',
		combodateFormat : 'YYYY-MM-DD',

		fulldatewshortmonth: 'DD MMM dddd YYYY' // 13 May Persembe 2025
	};


	dateFormats['fr'] = {		
		fulldate 			: 'dddd D MMMM YYYY', // OK
		date 				: 'D MMMM YYYY', // OK
		fulldayfullmonth 	: 'dddd D MMMM', // OK
		datewday 			: 'D MMM ddd', // OK
		dayfullmonth 		: 'D MMMM', // OK
		dayshortmonth 		: 'D MMM', // OK
		daytextday 			: 'ddd D',  // OK
		
		daymonth : 'DD MMM',
		shortmonthyear : 'MMM YYYY',
		monthyear : 'MMMM YYYY',
		
		combodateTemplate : 'D MMMM YYYY',
		combodateFormat : 'YYYY-MM-DD',

		fulldatewshortmonth: 'DD MMM dddd YYYY' // 13 May Persembe 2025
	};

	dateFormats['it'] = {		
		fulldate 			: 'dddd D MMMM YYYY', // OK
		date 				: 'D MMMM YYYY', // OK
		fulldayfullmonth 	: 'dddd D MMMM', // OK
		datewday 			: 'ddd. D MMM', // OK
		dayfullmonth 		: 'D MMMM', // OK
		dayshortmonth 		: 'D MMM', // OK
		daytextday 			: 'ddd. D',  // OK
		
		daymonth : 'DD MMM',
		shortmonthyear : 'MMM YYYY',
		monthyear : 'MMMM YYYY',
		
		combodateTemplate : 'D MMMM YYYY',
		combodateFormat : 'YYYY-MM-DD',

		fulldatewshortmonth: 'DD MMM dddd YYYY' // 13 May Persembe 2025
	};
	
	dateFormats['cn'] = {
		fulldate 			: 'YYYY MMMM D, dddd', // OK
		date 				: 'YYYY MMMM D', // OK
		fulldayfullmonth 	: 'MMMM D, dddd', // OK
		datewday 			: 'MMM D ddd', // OK
		dayfullmonth 		: 'MMMM D', // OK
		dayshortmonth 		: 'MMM D', // OK
		daytextday 			: 'D, ddd',  // OK
		
		daymonth : 'DD MMM',
		shortmonthyear : 'MMM YYYY', 
		monthyear : 'MMMM YYYY',
		
		combodateTemplate : 'D MMMM YYYY',
		combodateFormat : 'YYYY-MM-DD',

		fulldatewshortmonth: 'DD MMM dddd YYYY' // 13 May Persembe 2025
	};

	dateFormats['zh'] = {
			fulldate 			: 'YYYY MMMM D , dddd', // OK
			date 				: 'YYYY MMMM D', // OK
			fulldayfullmonth 	: 'MMMM D, dddd', // OK
			datewday 			: 'MMM D  ddd', // OK
			dayfullmonth 		: 'MMMM D', // OK
			dayshortmonth 		: 'MMM D', // OK
			daytextday 			: 'D, ddd',  // OK
			
			daymonth : 'DD MMM',
			shortmonthyear : 'MMM YYYY', 
			monthyear : 'MMMM YYYY',
			
			combodateTemplate : 'D MMMM YYYY',
			combodateFormat : 'YYYY-MM-DD',

			fulldatewshortmonth: 'DD MMM dddd YYYY' // 13 May Persembe 2025
		};	
	
	dateFormats['ja'] = {

		fulldate 			: 'YYYY 年 M 月 D 日 (dddd)', // OK
		date 				: 'YYYY 年 M 月 D 日', // OK
		fulldayfullmonth 	: 'M 月 D 日 (dddd)', // OK
		datewday 			: 'M 月 D 日 (ddd)', // OK
		dayfullmonth 		: 'M 月 D 日', // OK
		dayshortmonth 		: 'M 月 D 日', // OK
		daytextday 			: 'D 日 (ddd)',  // OK

		daymonth : 'M 月 DD 日',
		shortmonthyear : 'YYYY 年 M 月', 
		monthyear : 'YYYY 年 M 月',
		
		combodateTemplate : 'D MMMM YYYY',
		combodateFormat : 'YYYY-MM-DD',

		fulldatewshortmonth: 'DD MMM dddd YYYY' // 13 May Persembe 2025
			
	};

	dateFormats['es'] = {
			fulldate 			: 'dddd[,] D MMMM YYYY',
			date 				: 'D MMMM YYYY',
			fulldayfullmonth 	: 'dddd[,] D MMMM',
			datewday 			: 'ddd D MMM',
			dayfullmonth 		: 'D MMMM',
			dayshortmonth 		: 'D MMM',
			daytextday 			: 'ddd D',
			
			daymonth : 'DD MMM',
			shortmonthyear : 'MMM YYYY',
			monthyear : 'MMMM YYYY',
			
			combodateTemplate : 'D MMMM YYYY',
			combodateFormat : 'YYYY-MM-DD',

			fulldatewshortmonth: 'DD MMM dddd YYYY' // 13 May Persembe 2025
		};
	
	dateFormats['pt'] = {
			
			fulldate 			: 'dddd, D [de] MMMM [de] YYYY', // ok
			date 				: 'D [de] MMMM [de] YYYY', // ok
			fulldayfullmonth 	: 'dddd, MMMM D', // ok
			datewday 			: 'ddd, MMM D', // ok
			dayfullmonth 		: 'D [de] MMMM', // ok
			dayshortmonth 		: 'D MMM', // ok
			daytextday 			: 'dddd, D', // ok
			
			daymonth : 'DD MMM',
			shortmonthyear : 'MMM YYYY',
			monthyear : 'MMMM YYYY',
			
			combodateTemplate : 'D MMMM YYYY',
			combodateFormat : 'YYYY-MM-DD',

			fulldatewshortmonth: 'DD MMM dddd YYYY' // 13 May Persembe 2025

		};

	dateFormats['ru'] = {
		date : 'D MMMM YYYY г.',
		fulldate : 'dddd, D MMMM YYYY г.',
		dayfullmonth : 'D MMMM',
		fulldayfullmonth : 'dddd D MMMM',
		daytextday : 'dddd, D',
		dayshortmonth : 'D MMM',
		
		shortmonthyear : 'MMM YYYY',
		monthyear : 'MMMM YYYY',
		
		combodateTemplate : 'D MMMM YYYY',
		combodateFormat : 'YYYY-MM-DD',

		fulldatewshortmonth: 'DD MMM dddd YYYY' // 13 May Persembe 2025
	};


    dateFormats['uk'] = {
        date : 'D MMMM YYYY г.',
        fulldate : 'dddd, D MMMM YYYY г.',
        dayfullmonth : 'D MMMM',
        fulldayfullmonth : 'dddd D MMMM',
        daytextday : 'dddd, D',
        dayshortmonth : 'D MMM',

        shortmonthyear : 'MMM YYYY',
        monthyear : 'MMMM YYYY',

        combodateTemplate : 'D MMMM YYYY',
        combodateFormat : 'YYYY-MM-DD',

		fulldatewshortmonth: 'DD MMM dddd YYYY' // 13 May Persembe 2025
    };
	  dateFormats['th'] = {
		fulldate 			: 'D MMMM YYYY dddd',  
		date 				: 'D MMMM YYYY', 
		fulldayfullmonth 	: 'D MMMM dddd',
		datewday 			: 'D MMM ddd',
		dayfullmonth 		: 'D MMMM',
		dayshortmonth 		: 'D MMM',
		daytextday 			: 'ddd D',
		
		daymonth : 'DD MMM',
		shortmonthyear : 'MMM YYYY',
		monthyear : 'MMMM YYYY', 
		
		combodateTemplate : 'D MMMM YYYY',
		combodateFormat : 'YYYY-MM-DD',

	  	fulldatewshortmonth: 'DD MMM dddd YYYY' // 13 May Persembe 2025
	};
	return dateFormats;

});
